module.exports = __webpack_public_path__ + "static/description-screen-0d60995472273b877b0e554eb66f9e91.png";